import { Button } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { IActions } from '../../interface';

const Actions = (props: IActions) => {
  const { isLoading, handleApproval, toggleRejectionModal } = props;
  return (
    <div className={styles.actionsContainer}>
      <Button
        variant="secondary"
        disabled={isLoading}
        className={styles.rejectBtn}
        onClick={toggleRejectionModal}
      >
        Reject
      </Button>
      <Button disabled={isLoading} className={styles.approveBtn} onClick={handleApproval}>
        Approve
      </Button>
    </div>
  );
};

export default Actions;
